import { palette } from '../../settings/themes/colors.js';

export const STATUS_CHIP_COLORS = {
  'project.inspection.status.published': palette.captuDataYellow,
  'project.inspection.status.initial': palette.dimGray
};

export const statusKeyFromPublished = published => {
  if (published === true) return 'project.inspection.status.published';
  if (published === false) return 'project.inspection.status.initial';

  return null;
};
